import { MDText } from 'i18n-react';

import { LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import { usePageRefEvents } from '../../../../common/Hooks/usePageRefEvents';
import { RoundedSection } from '../../../../common/RoundedSection/RoundedSection';
import { getYouTubeEmbedUrl } from '../../../Components/ContentBlock/ContentBlock.helpers';
import { carPrizeDrawSectionLoadEvent } from '../CarPrizeDraw.helpers';

import LocalTexts from './QuotesSection.texts.json';

import styles from './QuotesSection.module.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

const YOUTUBE_VIDEO_URL = 'https://www.youtube.com/watch?v=SmPp7nRLE9c';

export const QuotesSection = () => {
  const onRefTrigger = () => carPrizeDrawSectionLoadEvent(LANDING_PAGE_SECTIONS_NAMES.QUOTES);

  const { setRef } = usePageRefEvents({ onRefTrigger });

  const embedUrl = getYouTubeEmbedUrl(YOUTUBE_VIDEO_URL);

  return (
    <RoundedSection withBottomLedge withTopLedge theme="primary-mid-light-yellow">
      <div ref={(ref) => setRef(ref)} className={styles.component} data-testid="quotesSection">
        <h2 className={styles.title}>
          {t('title')}
        </h2>
        <div className={styles.video}>
          {embedUrl && (
            <iframe
              allowFullScreen
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              data-testid="youtube-vid-player"
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              src={embedUrl}
              title={t('video.title')}
            />
          )}
          <p data-thc-style-override className={styles.attribution}>
            <b>{t('quotes.1.attribution.name')}</b> {t('quotes.1.attribution.location')}
          </p>
        </div>
        <div className={styles.quoteCard}>
          <p data-thc-style-override className={styles.quote}>
            {t('quotes.0.quote')}
          </p>
          <p data-thc-style-override className={styles.attribution}>
            <b>{t('quotes.0.attribution.name')}</b> {t('quotes.0.attribution.location')}
          </p>
        </div>
      </div>
    </RoundedSection>
  );
};
